var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10663_110882)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_10663_110882)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.54662 0.355145L11.8567 5.25975C11.9416 5.44502 12.1134 5.57574 12.3145 5.60827L17.4801 6.39476C17.7136 6.44004 17.9033 6.61009 17.9738 6.83729C18.0442 7.06449 17.984 7.31202 17.8171 7.48149L14.0793 11.2992C13.9349 11.4488 13.87 11.658 13.9044 11.8631L14.7868 17.2538C14.8349 17.4855 14.7457 17.7243 14.5573 17.8677C14.369 18.011 14.1151 18.0335 13.9045 17.9254L9.28431 15.3803C9.1083 15.2827 8.89444 15.2827 8.71843 15.3803L4.0982 17.9254C3.88764 18.0335 3.63372 18.011 3.4454 17.8677C3.25708 17.7243 3.16784 17.4855 3.21598 17.2538L4.09837 11.8631C4.1327 11.658 4.06783 11.4488 3.9235 11.2992L0.185656 7.48149C0.0187307 7.31202 -0.0414728 7.06449 0.0289791 6.8373C0.0994309 6.6101 0.289121 6.44006 0.522637 6.39478L5.68821 5.60827C5.88939 5.57574 6.0611 5.44502 6.14601 5.25976L8.45613 0.355145C8.55154 0.13926 8.76534 0 9.00137 0C9.2374 0 9.4512 0.13926 9.54662 0.355145Z",
    fill: "url(#paint0_linear_10663_110882)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2957 4.06861C9.80578 4.86528 8.42996 5.85905 7.20538 7.0231C5.90022 8.27256 4.79303 9.71358 3.92193 11.2965L0.185408 7.48241C0.0184909 7.31285 -0.0415505 7.06518 0.029188 6.838C0.0999265 6.61083 0.289961 6.44103 0.523635 6.3962L5.68782 5.60792C5.88873 5.57456 6.06042 5.44462 6.14713 5.26034L8.45607 0.353787C8.55252 0.138533 8.7664 0 9.00228 0C9.23815 0 9.45203 0.138533 9.54848 0.353787L11.2957 4.06861Z",
    fill: "url(#paint1_linear_10663_110882)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_10663_110882",
    x: 0,
    y: 0,
    width: 18,
    height: 21.9932,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.862754 0 0 0 0 0.572115 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_10663_110882"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10663_110882",
    x1: 6.05415,
    y1: 0.62069,
    x2: 19.2438,
    y2: 21.4138,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC9F15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10663_110882",
    x1: 0.00242462,
    y1: 6.82759,
    x2: 16.2955,
    y2: 2.17241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD969"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEF4CA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10663_110882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.e38b57b0adabc8dbf83724a632e1be03.svg";
export { ForwardRef as ReactComponent };